import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';
import GlobalSelectors from '../../store/global-selectors';
import * as Api from './rate-viewer.api';
import * as Actions from './rate-viewer.actions';
import { allPackageTypes } from '../../fulfillment-planner/package/dropdown/package-group-resolver';

export const loadRates = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.RATE_VIEWER_LOAD_RATES),
    mergeMap((action) => {
      const state = getState();
      const { model, rateViewerKey } = action;
      const rateRequestModel = {
        ...model,
        packageId: model.packageId === allPackageTypes.packageId ? undefined : model.packageId,
        packageTypeId: model.packageTypeId === allPackageTypes.packageTypeId ? undefined : model.packageTypeId,
        fulfillmentPlanId: rateViewerKey === 'rateBrowser' ? null : rateViewerKey,
      };
      return Api.startLoadingRates(rateRequestModel).pipe(
        mergeMap((jobGuid) => {
          const rates = GlobalSelectors.selectSellerLabelProviders(state).map((prov) => ({
            ...prov,
            rates: emptyArray,
            isLoading: true,
          }));
          return of(Actions.startLoadingRates(rateViewerKey, jobGuid, rates));
        }),
        catchError((payload) => {
          const errors = get(payload, 'response.data.Errors', emptyArray).map((error) => error.Message);
          return of(Actions.startLoadingRatesError(rateViewerKey, errors));
        }),
      );
    }),
  );
};

const withRateViewerInstance = (state, jobGuid) => (fn$) => {
  const allInstances = GlobalSelectors.selectRateViewerAllInstances(state);
  const foundKey = Object.keys(allInstances).find((key) => {
    return get(allInstances, `${key}.jobGuid`) === jobGuid;
  });

  const foundInstance = allInstances[foundKey];

  if (!foundInstance) {
    return EMPTY;
  }
  return of(fn$(foundKey, foundInstance));
};

export const rateRecievedErrorPre = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.RATE_VIEWER_ON_RATE_RECIEVED_ERROR_PRE),
    mergeMap((action) => {
      const state = getState();
      const { jobGuid, errorPayload } = action;
      return withRateViewerInstance(
        state,
        jobGuid,
      )((rateBrowserKey) => {
        return Actions.onRatesRecievedError(rateBrowserKey, errorPayload);
      });
    }),
  );
};

const correctServiceNames = (state, providerRate) => {
  const shippingServices = GlobalSelectors.selectSellergetShippingServices(state);
  const { rates } = providerRate;
  return {
    ...providerRate,
    rates: rates.map((rate) => {
      const { serviceId, rateName } = rate;
      const matchingService = shippingServices[serviceId];
      return {
        ...rate,
        rateName: get(matchingService, 'name', rateName),
      };
    }),
  };
};

export const rateRecievedSuccessPre = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS_PRE),
    mergeMap((action) => {
      const state = getState();
      const { jobGuid, data } = action;
      return withRateViewerInstance(
        state,
        jobGuid,
      )((rateBrowserKey) => {
        const providerRate = correctServiceNames(state, data);
        return Actions.onRatesRecievedSuccess(rateBrowserKey, providerRate);
      });
    }),
  );
};
